import React from 'react'

const FonctionnementPage = () => {
  return (
    <div className='min-h-screen bg-gray-100 p-6 flex flex-col items-center'>
      <div className='bg-white rounded-lg shadow-lg p-8 max-w-4xl'>
        <h1 className='text-4xl font-bold mb-6 text-center' style={{ color: '#ff5733' }}>
          Découvrez le Fonctionnement de Voyo
        </h1>
        <p className='text-gray-700 mb-6'>
          Bienvenue sur Voyo, votre allié pour simplifier la recherche de logement. Découvrez
          comment notre plateforme facilite la délégation de visites de biens à louer. Voici les
          étapes clés du fonctionnement :
        </p>

        <section className='mb-6'>
          <h2 className='text-2xl font-semibold mb-4' style={{ color: '#ff5733' }}>
            1. Inscrivez-vous Facilement
          </h2>
          <p className='text-gray-700'>
            Commencez par créer votre compte en quelques clics. Il vous suffit de renseigner
            quelques informations de base (nom, adresse e-mail) pour accéder à toutes les
            fonctionnalités de Voyo.
          </p>
        </section>
        <section className='mb-6'>
          <h2 className='text-2xl font-semibold mb-4' style={{ color: '#ff5733' }}>
            2. Mandants et Visiteurs
          </h2>
          <p className='text-gray-700'>
            Chez Voyo, nous mettons en relation deux types d&apos;utilisateurs : les mandants et les
            visiteurs.
            <ul className='list-disc list-inside text-gray-700'>
              <li>
                <strong>👤 Mandants</strong> : Ce sont les personnes à la recherche d’un logement à
                louer. Ils peuvent chercher un visiteur de deux façons :
                <br />
                Avec une date et une adresse précises : dans ce cas, le site affiche les visiteurs
                disponibles à ce moment et à cet endroit.
                <br />
                Ou sans avoir encore tous les détails : il est possible d’indiquer simplement une ou
                plusieurs zones géographiques. Voyo proposera alors des visiteurs dans le périmètre
                choisi. Le mandant pourra échanger avec eux afin de définir ensemble une ou
                plusieurs propositions à présenter ensuite à l’agent immobilier ou au propriétaire
              </li>
              <li>
                <strong>👀 Visiteurs</strong> Ce sont les personnes prêtes à effectuer des visites
                de biens à la place des mandants. Chaque visiteur dispose d’un profil avec ses
                disponibilités, son secteur d’intervention, et des éléments de confiance (avis,
                expérience, etc.).
              </li>
            </ul>
          </p>
        </section>

        <section className='mb-6'>
          <h2 className='text-2xl font-semibold mb-4' style={{ color: '#ff5733' }}>
            3. Sélectionnez Votre Visiteur Idéal
          </h2>
          <p className='text-gray-700'>
            Une fois que les critères de recherche sont définis, le mandant consulte les profils
            disponibles. Il peut ensuite choisir le visiteur qui correspond le mieux à ses attentes
            (disponibilité, localisation, compétences, etc.).
          </p>
        </section>

        <section className='mb-6'>
          <h2 className='text-2xl font-semibold mb-4' style={{ color: '#ff5733' }}>
            4. Proposez une Visite au Visiteur Sélectionné
          </h2>
          <p className='text-gray-700'>
            Après avoir sélectionné un visiteur, le mandant lui propose une visite. Le visiteur peut
            l’accepter ou échanger pour ajuster la date et l’heure.
          </p>
        </section>

        <section className='mb-6'>
          <h2 className='text-2xl font-semibold mb-4' style={{ color: '#ff5733' }}>
            5. Option d&apos;Urgence pour les Zones Tendues
          </h2>
          <p className='text-gray-700'>
            Dans les zones tendues (comme Paris), où les biens partent vite, Voyo propose une
            fonctionnalité d’urgence : les visiteurs peuvent indiquer leur disponibilité immédiate.
            Cela permet aux mandants de réagir rapidement lorsqu’une opportunité se présente.
          </p>
        </section>

        <section className='mb-6'>
          <h2 className='text-2xl font-semibold mb-4' style={{ color: '#ff5733' }}>
            6. Confirmation de la Visite
          </h2>
          <p className='text-gray-700'>
            Lorsque le visiteur accepte la proposition, la visite est confirmée et planifiée selon
            les disponibilités de chacun.
          </p>
        </section>

        <section className='mb-6'>
          <h2 className='text-2xl font-semibold mb-4' style={{ color: '#ff5733' }}>
            7. La Visite en Action
          </h2>
          <p className='text-gray-700'>
            Le visiteur se rend sur place, effectue la visite à la date prévue, prend photos,
            vidéos, et notes détaillées pour transmettre un compte rendu fidèle au mandant.
          </p>
        </section>

        <section className='mb-6'>
          <h2 className='text-2xl font-semibold mb-4' style={{ color: '#ff5733' }}>
            8. Le Compte Rendu Détaillé
          </h2>
          <p className='text-gray-700'>
            Après la visite, le visiteur télécharge un compte rendu complet sur la plateforme. Le
            mandant est immédiatement notifié dès que le document est prêt.
          </p>
        </section>

        <section className='mb-6'>
          <h2 className='text-2xl font-semibold mb-4' style={{ color: '#ff5733' }}>
            9. Approbation et Paiement
          </h2>
          <p className='text-gray-700'>
            Le mandant consulte le compte rendu. Si le service a été à la hauteur, il valide la
            prestation et le paiement est libéré en faveur du visiteur.
          </p>
        </section>

        <section className='mb-6'>
          <h2 className='text-2xl font-semibold mb-4' style={{ color: '#ff5733' }}>
            10. Remboursement en Cas de Non-Satisfaction
          </h2>
          <p className='text-gray-700'>
            Si la visite n’a pas été satisfaisante ou ne respecte pas les termes convenus, le
            mandant peut demander un remboursement partiel ou total, conformément à notre politique
            de remboursement.
          </p>
        </section>

        <section className='mb-6'>
          <h2 className='text-2xl font-semibold mb-4' style={{ color: '#ff5733' }}>
            11. Devenir Visiteur
          </h2>
          <p className='text-gray-700'>
            Vous souhaitez devenir visiteur sur Voyo ? Bienvenue ! Nous valorisons les utilisateurs
            responsables et fiables. Vous pouvez retrouver toutes les informations pour devenir
            visiteur directement depuis votre espace personnel.
          </p>
        </section>

        <p className='text-gray-700'>
          Chez Voyo, notre mission est de simplifier la recherche de logement, en offrant un moyen
          fiable et sécurisé de déléguer les visites. Transparence, flexibilité et confiance sont au
          cœur de notre fonctionnement.
        </p>
        <p className='text-gray-700 mt-4'>
          Pour toute question, notre équipe reste à votre écoute. Bonne recherche de logement avec
          Voyo !
        </p>
      </div>
    </div>
  )
}

export default FonctionnementPage
